<template>
	<div>
		<div class="backgroundImage">
			<img src="../assets/image/headBackground.png" alt="" class="broundImage" />
			<div class="contentser">
				<div class="temperature">
					<div class="degree">
						<div>{{local.temperature}}</div>
						<div>°C</div>
						<div>{{local.weather}}</div>
					</div>
					<div style='display: flex;align-items: center;margin-top: 5px;'>
						<img src="../assets/icon/location.png" alt=""
							style="width: 18px;height: 18px;margin-right: 5px;" />
						<div class="addressLocation"> {{location.city}} {{location.district}}</div>
					</div>
				</div>
				<div class="exhibition">
					<img src="../assets/icon/cloud.png" alt="" class="cloudMap" />
					<img src="../assets/icon/weather1.png" alt="" class="weatherMap"
						v-if="local.weather=='阵雪'||local.weather=='小雪'||local.weather=='中雪'||local.weather=='暴雪'||local.weather=='大雪'||local.weather=='小到中雪'||local.weather=='中到大雪'||local.weather=='大到暴雪'||local.weather=='雪'" />
					<img src="../assets/icon/weather2.png" alt="" class="weatherMap" v-if="local.weather=='雨夹雪'" />
					<img src="../assets/icon/weather3.png" alt="" class="weatherMap"
						v-if="local.weather=='多云'||local.weather=='阴'" />
					<img src="../assets/icon/weather4.png" alt="" class="weatherMap"
						v-if="local.weather=='阵雨'||local.weather=='雷阵雨'||local.weather=='雷阵雨伴有冰雹'||local.weather=='雨'||local.weather=='冻雨'||local.weather=='小到中雨'||local.weather=='中到大雨'||local.weather=='大到暴雨'||local.weather=='暴雨到大暴雨'||local.weather=='大暴雨到特大暴雨'" />
					<img src="../assets/icon/weather6.png" alt="" class="weatherMap"
						v-if="local.weather=='浮尘'||local.weather=='扬沙'||local.weather=='强沙尘暴'||local.weather=='浓雾'||local.weather=='强浓雾'||local.weather=='霾'||local.weather=='中度霾'||local.weather=='重度霾'||local.weather=='严重霾'||local.weather=='大雾'||local.weather=='特强浓雾'" />
					<img src="../assets/icon/weather7.png" alt="" class="weatherMap" v-if="local.weather=='晴天'" />
				</div>
				<div class="weatherInformation">
					<div class="singleWeather">
						<img src="../assets/icon/windSpeed.png" alt="" />
						<div>{{local.wind_direction}}</div>
						<div>{{local.wind_power}}</div>
					</div>
					<div class="singleWeather">
						<img src="../assets/icon/cloudiness.png" alt="" />
						<div>湿度</div>
						<div>{{local.temperature}}%</div>
					</div>
					<div class="singleWeather">
						<img src="../assets/icon/visibility.png" alt="" />
						<div>温度</div>
						<div>{{local.humidity}}°C</div>
					</div>
					<div class="singleWeather">
						<img src="../assets/icon/precipitation.png" alt="" />
						<div>天气</div>
						<div>{{local.weather}}</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		setContent,
		weather
	} from "@/api/api.js"
	import axios from 'axios'
	export default {
		data() {
			return {
				customerService: '',
				// 当地信息（城市、时间、地点、天气）
				local: '',
				// 经纬度信息
				location: {
					lat: null,
					lng: null
				},

			}
		},
		created() {
			this.setUp()
			this.getLocalCity()
		},
		methods: {
			getLocalCity() {
				var data = {
					key: 'ZOUBZ-IS3YI-3RLGL-UJMAF-ISHQ7-ATBGN'
				}
				var url = 'https://apis.map.qq.com/ws/location/v1/ip' //这个就是地理位置信息的接口
				data.output = 'jsonp'
				this.$jsonp(url, data)
					.then((res) => {
						console.log(res, '132124')
						this.location = res.result.ad_info
						// localStorage.setItem('location', JSON.stringify(this.location))
						// 根据城市，获取当前天气和时间（在此先预留获取天气方法，完成后取消注释）
						this.getLocalWeather(res.result.location) // 这里就是调用下面的那个
						return res
					})
					.catch((error) => {
						console.log(error)
					})
			},
			getLocalWeather(e) {
				weather({
					latitude: e.lat,
					longitude: e.lng
				}).then(res => {
					this.local = res.data
					localStorage.setItem('local', JSON.stringify(this.local))
				})
				// console.log(location, '12312')
				// axios.get(
				// 	`https://apis.map.qq.com/ws/weather/v1/?adcode=${location.adcode}&key=ZOUBZ-IS3YI-3RLGL-UJMAF-ISHQ7-ATBGN`
				// 	// `https://devapi.qweather.com/v7/weather/now?location=${location.lng},${location.lat}&key=你的和风天气的key`
				// ).then(res => {
				// 	console.log(res)
				// 	this.local = res.data.result.realtime[0].infos
				// 	// console.log(this.local.temperature)
				// })
			},
			setUp() {
				setContent({
					groupKey: "kf"
				}).then(res => {
					this.customerService = res.data
				})

			}
		}
	}
</script>

<style lang="scss" scoped>
	.backgroundImage {
		width: 100%;
		height: 200px;
		position: relative;

		.broundImage {
			width: 100%;
			height: 200px;
		}

		.contentser {
			position: absolute;
			left: 0;
			right: 0;
			top: 37px;
			width: 1100px;
			margin: 0 auto;
			display: flex;

			.temperature {
				.degree {
					display: flex;

					div:nth-of-type(1) {
						font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
						font-weight: normal;
						font-size: 70px;
						color: #222222;
					}

					div:nth-of-type(2) {
						font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
						font-weight: normal;
						font-size: 30px;
						color: #222222;
					}

					div:nth-of-type(3) {
						font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
						font-weight: normal;
						font-size: 30px;
						color: #222222;
						margin-top: 38px;
					}
				}

				.addressLocation {
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 16px;
					color: #323433;
				}
			}

			.exhibition {
				width: 324px;
				height: 133px;
				position: relative;
				margin-left: 30px;

				.cloudMap {
					width: 324px;
					height: 133px;
				}

				.weatherMap {
					position: absolute;
					right: 0;
					top: -20px;
					width: 130px;
					height: 130px;
				}
			}

			.weatherInformation {
				width: 440px;
				height: 96px;
				background: rgba(255, 255, 255, 0.3);
				border-radius: 7px 7px 7px 7px;
				border: 1px solid #F2F2F2;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-left: 147px;

				.singleWeather {
					text-align: center;
					margin: 0 auto;
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 14px;
					color: #2B3344;

					img {
						width: 35px;
						height: 35px;
					}
				}
			}
		}


	}
</style>